import React from 'react';
import PropTypes from 'prop-types';

export const Tab = ({ children, className }) => <div className={`tab-content-panel ${className || ''}`}>{children}</div>;

Tab.propTypes = { children: PropTypes.any };

export class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: this.getDefaultIndex(props.defaultIndex) };
  }

  getDefaultIndex = index => (Number.isInteger(index) && index >= 0 ? index : 0);

  componentDidUpdate(prevProps) {
    const prevIndex = this.getDefaultIndex(prevProps.defaultIndex);
    const nextIndex = this.getDefaultIndex(this.props.defaultIndex);

    if (nextIndex !== prevIndex && nextIndex !== this.state.activeIndex) {
      this.setState({ activeIndex: nextIndex });
    }
  }

  onClick = index => {
    this.setState({ activeIndex: index });
    if (this.props.onChange) {
      this.props.onChange(index);
    }
  };

  render() {
    const { activeIndex } = this.state;
    const safeActiveIndex = this.getDefaultIndex(activeIndex);
    const content = this.props.children?.[safeActiveIndex] || null;

    const tabs = React.Children.map(this.props.children, (child, index) => {
      const style = safeActiveIndex === index ? 'tabButton tab-label active-tab-label' : 'tabButton tab-label';
      const key = String(child?.key ?? `tab-${index}`);
      return (
        <button
          className={style}
          onClick={() => this.onClick(index)}
          data-testid={`tab[${key.toLowerCase()}]`}
        >
          {`${child.props.label}${!isNaN(child.props.count) ? ` (${child.props.count})` : ''}`}
        </button>
      );
    });
    return (
      <div className={`tabs-container ${this.props.containerClassName || ''}`}>
        <div className="tab-buttons-row">
          {tabs}
          {this.props.rightContent && <div className="tab-buttons-right">{this.props.rightContent}</div>}
        </div>
        {this.props.contentHeader}
        {content}
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.any,
  contentHeader: PropTypes.any,
  defaultIndex: PropTypes.number,
  rightContent: PropTypes.any,
};

Tabs.defaultProps = { defaultIndex: 0 };
